import React from "react";

import { withStyles } from "@material-ui/core/styles";
import { styles } from "./styles";
import { Box } from "@material-ui/core";
import { useTranslation } from "react-i18next";

const Footer = (props) => {
  const { classes } = props;

  const { t } = useTranslation();

  const footerOptionalText = t("footerText", { ns: "temporaryTexts" });

  return (
    footerOptionalText &&
    footerOptionalText !== "footerText" && (
      <Box className={classes.boxFooter} color="white" bgcolor={`#404040`}>
        <footer>*** {footerOptionalText} ***</footer>
      </Box>
    )
  );
};

export default withStyles(styles)(Footer);
